import postCreatorTour from './postCreatorTour'
import plannerTour from './plannerTour'
import plannerReturnTour from './plannerReturnTour'
import botsTour from './botsTour'
import reportingTour from './reportingTour'
import moderationTour from './moderationTour'
import pagesTour from './pagesTour'
import settingsTour from './settingsTour'

const tourRegistry = {
  [postCreatorTour.id]: postCreatorTour,
  [plannerTour.id]: plannerTour,
  [plannerReturnTour.id]: plannerReturnTour,
  [botsTour.id]: botsTour,
  [reportingTour.id]: reportingTour,
  [moderationTour.id]: moderationTour,
  [pagesTour.id]: pagesTour,
  [settingsTour.id]: settingsTour
}

export function getTourConfig(tourId) {
  return tourRegistry[tourId] || null
}

export default tourRegistry
